import { render, staticRenderFns } from "./importAnnex.vue?vue&type=template&id=6789fa69&scoped=true&"
import script from "./importAnnex.vue?vue&type=script&lang=js&"
export * from "./importAnnex.vue?vue&type=script&lang=js&"
import style0 from "./importAnnex.vue?vue&type=style&index=0&id=6789fa69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6789fa69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6789fa69')) {
      api.createRecord('6789fa69', component.options)
    } else {
      api.reload('6789fa69', component.options)
    }
    module.hot.accept("./importAnnex.vue?vue&type=template&id=6789fa69&scoped=true&", function () {
      api.rerender('6789fa69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/importAnnex.vue"
export default component.exports